<section class="medical-history">
  <span class="subsection">{{ labelService.getLabel("personal") }}</span>
  <hr />
  @for (elem of anamnesisPersonalFields; track elem) {
    <div class="personal-row">
      <span>{{ labelService.getLabel(elem) }}</span>
      <input
        type="text"
        [(ngModel)]="anamnesis[elem]"
        [readOnly]="fieldIsReadOnly"
      />
    </div>
  }
</section>

<section class="medical-history">
  <div class="family-divider">
    <span class="subsection">{{ labelService.getLabel("familiar") }}</span>
    <mat-icon style="cursor: pointer" (click)="toggleNewRelativePanel()"
      >add</mat-icon
    >
  </div>
  <hr />
  @for (familyMember of familyMembers; track familyMember) {
    <div class="family-row">
      @if (!fieldIsReadOnly) {
        <span
          style="cursor: pointer"
          class="material-icons"
          (click)="deleteFamilyMember(familyMember)"
          >delete</span
        >
      }
      <span class="relationship">{{ familyMember.relationship }}</span>
      <div class="family-fields-container">
        <div class="family-field">
          <span>Nome</span>
          <input
            type="text"
            [(ngModel)]="familyMember.name"
            [readOnly]="fieldIsReadOnly"
          />
        </div>
        <div class="family-field">
          <span>Occupazione</span>
          <input
            type="text"
            [(ngModel)]="familyMember.occupation"
            [readOnly]="fieldIsReadOnly"
          />
        </div>
        <div class="family-field">
          <span>Età</span>
          <input
            type="text"
            [(ngModel)]="familyMember.age"
            [readonly]="fieldIsReadOnly"
          />
        </div>
        <div class="family-field">
          <span>Altro</span>
          <input
            type="text"
            [(ngModel)]="familyMember.other"
            [readOnly]="fieldIsReadOnly"
          />
        </div>
      </div>
    </div>
  }
</section>

<section class="medical-history">
  <span class="subsection">{{
    labelService.getLabel("clinical_history")
  }}</span>
  <hr />
  @for (elem of anamnesisClinicHistoryFields; track elem) {
    <div class="personal-row">
      <span>{{ labelService.getLabel(elem) }}</span>
      <input
        type="text"
        [(ngModel)]="anamnesis[elem]"
        [readOnly]="fieldIsReadOnly"
      />
    </div>
  }
</section>

<!-- add relative panel -->
@if (showAddRelativePanel) {
  <app-panel-with-input-boxes
    [title]="'Nuovo Familiare'"
    [inputBoxes]="inputBoxesForNewFamilyMember"
    (cancel)="toggleNewRelativePanel()"
    (confirm)="addNewRelative($event)"
  ></app-panel-with-input-boxes>
}
